/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ResetOktaResourceConnectionRequestBody = {
  /**
   * Server to reset.
   */
  mcpServerId: string;
};

/** @internal */
export type ResetOktaResourceConnectionRequestBody$Outbound = {
  mcp_server_id: string;
};

/** @internal */
export const ResetOktaResourceConnectionRequestBody$outboundSchema:
  z.ZodMiniType<
    ResetOktaResourceConnectionRequestBody$Outbound,
    ResetOktaResourceConnectionRequestBody
  > = z.pipe(
    z.object({
      mcpServerId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
      });
    }),
  );

export function resetOktaResourceConnectionRequestBodyToJSON(
  resetOktaResourceConnectionRequestBody:
    ResetOktaResourceConnectionRequestBody,
): string {
  return JSON.stringify(
    ResetOktaResourceConnectionRequestBody$outboundSchema.parse(
      resetOktaResourceConnectionRequestBody,
    ),
  );
}
